import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import { StepperApiContext, StepperStateContext } from './Context';
import StepperController from './StepperController';

const Stepper = ({ children, onComplete }) => {
  const [state, setState] = useState(StepperController.getStateDefaults());
  const [controller] = useState(new StepperController(setState));

  const { isComplete } = state;

  useEffect(() => {
    if (isComplete) onComplete(state);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isComplete]);

  return (
    <StepperApiContext.Provider value={controller.getGateApi()}>
      <StepperStateContext.Provider value={state}>
        {children}
      </StepperStateContext.Provider>
    </StepperApiContext.Provider>
  );
};

Stepper.propTypes = {
  children: PropTypes.node.isRequired,
  onComplete: PropTypes.func.isRequired,
};

export default Stepper;
